<template>
  <b-row class="mt-1">
    <b-col cols="12">
      <tabela-repeticao
        v-model="servicosAdicionais"
        :colunas="colunasServicos"
        :bordered="true"
        :mostrar-footer="true"
        :tag-servico="true"
        :validar="validar"
        class="tabela-servicos-adicionais-proposta"
        @update-os-constituicao="updateCheckOsConstituicao"
        @open-modalo-obs="openModalObs($event)"
      >
        <template #headCell="{slotScope: {key}}">
          <span v-if="key == 'servico'">Bonificação</span>
        </template>

        <template #visualizacao="{slotScope: {item, key}}">
          <span
            v-if="key === 'servico' && item[key]"
          >
            {{ item[key].nome }}
            <tag-complemento-servico
              :servico="item"
              @editar-tag="editarTag($event)"
              @remover-tag="RemoveTag($event)"
            />
          </span>
          <span v-else-if="key === 'valorAuditar' && item['servico']">{{ item['servico'].valorAuditar | converteValor }}</span>
          <span v-else-if="key === 'acrescimo' && item[key]">{{ item[key] | converteValor }}</span>
          <span v-else-if="key === 'desconto' && item[key]">{{ item[key] | converteValor }}</span>
          <span
            v-else-if="key === 'subTotal'"
            :style="getSubTotal(item['servico'], item['acrescimo'], item['desconto']) <= 0 ? 'color:red' :''"
          >{{ getSubTotal(item['servico'], item['acrescimo'], item['desconto']) | converteValor }}</span>
        </template>

        <!-- Edição -->
        <template #edicao="{slotScope: {item, key, index}}">
          <servico-select
            v-if="key === 'servico'"
            v-model="item[key]"
            :label="''"
            :filtro-adicional="servicosNaoHonorarios"
            :invalido="item.erro && item.erro[key]"
            @input="updateCheckOsConstituicao(index)"
          />
          <span v-else-if="key == 'valorAuditar' && item['servico']">{{ item['servico'].valorAuditar | converteValor }}</span>
          <dinheiro-input
            v-else-if="key === 'acrescimo' && acresDesc === 'R$'"
            v-model="item[key]"
            @input="conferirDesconto($event, index)"
          />
          <b-input
            v-else-if="key === 'acrescimo' && acresDesc === '%'"
            v-model="item[key]"
            @blur="formataPorcentagemAcrescimo(item[key], index)"
            @input="conferirDesconto(item[key], index)"
          />
          <dinheiro-input
            v-else-if="key === 'desconto' && acresDesc === 'R$'"
            ref="descontoInput"
            v-model="item[key]"
            @input="valorComAcrescimo($event, index)"
          />
          <b-input
            v-else-if="key === 'desconto' && acresDesc === '%'"
            v-model="item[key]"
            :state="erroPorcentagem ? false : null"
            @blur="formataPorcentagemDesconto(item[key], index)"
            @input="valorComAcrescimo(item[key], index)"
          />
          <span
            v-else-if="key === 'subTotal' && item['servico']"
            :style="getSubTotal(item['servico'], item['acrescimo'], item['desconto']) <= 0 ? 'color:red': ''"
          >{{ getSubTotal(item['servico'], item['acrescimo'], item['desconto']) | converteValor }}</span>
        </template>

        <!-- -->
        <template #footTotal="{slotScope: {key}}">
          <span
            v-if="key == 'servico'"
            class="sub-total"
          >SubTotal</span>
          <span
            v-else-if="key === 'valorAuditar'"
            style="max-width: 150px;"
            class="valor-total"
          >{{ valorAuditarServicoAdicional | converteValor }}</span>
          <span
            v-else-if="key === 'acrescimo'"
            style="max-width: 110px;"
            class="valor-total"
          >{{ acresDesc === 'R$' ? valoAcrescimoServicoAdicional.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : `${valoAcrescimoServicoAdicional}%` }}</span>
          <span
            v-else-if="key == 'desconto'"
            style="max-width: 110px;"
            class="valor-total"
          >{{ acresDesc === 'R$' ? valorDescontoServicoAdicional.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : `${valorDescontoServicoAdicional}%` }}</span>
          <span
            v-else-if="key == 'subTotal'"
            style="max-width: 150px;"
            class="valor-total"
            :style="valorSubTotalServicoAdicional <= 0 && servicosAdicionais[0].servico ? 'color: red' : ''"
          >{{ valorSubTotalServicoAdicional | converteValor }}</span>
          <span v-else-if="key === 'acoes'" />
        </template>
      </tabela-repeticao>
    </b-col>
    <div>
      <modal-obs-servico
        ref="modalObsServico"
        v-model="servicosAdicionais"
        :index-save="indexSaveComplemento"
      />
    </div>
  </b-row>
</template>

<style lang="scss">
.tabela-servicos-adicionais-proposta {
  thead {
    tr {
      th {
        background-color: var(--table-bg) !important;
      }
    }
  }
}

.tags {
  display: flex;
  align-self: center;
  height: fit-content;

  .badge-outline-primary {
    border: 1px solid var(--primary) !important;
    background-color: transparent;
    color: var(--primary) !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(27rem);
  }

  .link {
    border-radius: 4px 0 0 4px;
    cursor: pointer;

    &:hover {
      text-decoration: underline var(--primary);
    }
  }

  .remove {
    padding: 0.2rem !important;
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
    border-radius: 0 4px 4px 0;
  }
}

.valor-total {
  word-break: break-all;
  // justify-content: flex-end;
  font-size: 13.2px;
  color: var(--text-primary) !important;
}

.sub-title-modal {
  font-size: 12px;
  color: gray;
  font-weight: 400;
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex'
import { verificaAcrescimo, valorParaComparar, verificaDesconto } from '@/app-modulo/comercial/cadastro-proposta/shared/services/validationServicos'

export default {
  name: 'TabelaServicoAdicional',
  components: {
    DinheiroInput: () => import('@/shared/components/dinheiro-input/DinheiroInput.vue'),
    TabelaRepeticao: () => import('@/shared/components/tabela-repeticao/TabelaRepeticao.vue'),
    ServicoSelect: () => import('@/shared/components/servico-select/ServicoSelect.vue'),
    modalObsServico: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/modal-complemento-servico/ModalComplementoServico.vue'),
    tagComplementoServico: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/tag-complemento-servico/TagComplementoServico.vue'),
  },
  props: {
    tipoAcresDesc: {
      type: String,
      default: 'R$',
    },
    value: {
      type: Array,
      default: () => [],
    },
    proposta: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      colunasServicos: [
        { key: 'servico', label: 'Serviços', thStyle: 'width: 420px;' },
        {
          key: 'valorAuditar', label: 'Valor', thStyle: 'width: 150px;',
        },
        {
          key: 'acrescimo', label: 'Acréscimo', thStyle: 'width: 120px;',
        },
        {
          key: 'desconto', label: 'Desconto', thStyle: 'width: 120px;',
        },
        {
          key: 'subTotal', label: 'Subtotal', thStyle: 'width: 150px;',
        },
      ],
      servicosAdicionais: [],
      acresDesc: 'R$',
      erroPorcentagem: false,
      newProposta: null,
      indexSaveComplemento: null,
    }
  },
  computed: {
    ...mapGetters('proposta', ['getCheckOsConstituicao']),
    valorAuditarServicoAdicional() {
      let totalAuditar = 0
      for (let index = 0; index < this.servicoAdicional.length; index += 1) {
        const element = this.servicoAdicional[index]
        if (element.servico) {
          totalAuditar += element.servico.valorAuditar
        }
      }
      return totalAuditar
    },
    valoAcrescimoServicoAdicional() {
      let acrescimoTotal = 0
      for (let index = 0; index < this.servicoAdicional.length; index += 1) {
        const element = this.servicoAdicional[index]
        if (element.acrescimo && this.acresDesc === '%' && typeof element.acrescimo === 'string') {
          acrescimoTotal += parseFloat(element.acrescimo.replace('%', ''), 10)
        } else if (element.acrescimo) {
          acrescimoTotal += element.acrescimo
        }
      }
      return acrescimoTotal
    },
    valorDescontoServicoAdicional() {
      let descontoTotal = 0
      for (let index = 0; index < this.servicoAdicional.length; index += 1) {
        const element = this.servicoAdicional[index]
        if (element.desconto && this.acresDesc === '%' && typeof element.desconto === 'string') {
          descontoTotal += parseFloat(element.desconto.replace('%', ''), 10)
        } else if (element.desconto) {
          descontoTotal += element.desconto
        }
      }
      return descontoTotal
    },
    valorSubTotalServicoAdicional() {
      let subTotal = 0
      let subTotalRCC = 0
      for (let index = 0; index < this.servicoAdicional.length; index += 1) {
        const element = this.servicoAdicional[index]
        let valorTotal = 0
        if (element.servico) {
          subTotal += element.servico.valorAuditar
          subTotalRCC += element.servico.valorRCC
        }

        if (element.acrescimo && this.acresDesc === '%' && typeof element.acrescimo === 'string') {
          subTotal += ((parseFloat(element.acrescimo.replace('%', ''), 10) / 100) * element.servico.valorAuditar)
          valorTotal += ((parseFloat(element.acrescimo.replace('%', ''), 10) / 100) * element.servico.valorAuditar)
        } else if (element.acrescimo) {
          subTotal += element.acrescimo
        }

        if (element.desconto && this.acresDesc === '%' && typeof element.desconto === 'string') {
          if (valorTotal > 0) {
            subTotal -= ((parseFloat(element.desconto.replace('%', ''), 10) / 100) * (valorTotal + element.servico.valorAuditar))
          } else {
            subTotal -= ((parseFloat(element.desconto.replace('%', ''), 10) / 100) * element.servico.valorAuditar)
          }
        } else if (element.desconto) {
          subTotal -= element.desconto
        }
      }

      this.$emit('subtotal-servicos-adicionais', { subTotal, subTotalRCC, tipo: 'servicoAdicional' })
      return subTotal
    },
    servicoAdicional: {
      get() {
        return this.servicosAdicionais
      },
    },
  },
  watch: {
    tipoAcresDesc(value, oldValue) {
      if (value && value !== oldValue) {
        this.acresDesc = value
        this.converteValores()
      }
    },
    value(value, oldValue) {
      if (value && value !== oldValue) {
        this.servicosAdicionais = value
        this.converteValores()
      }
    },
    proposta(value, oldValue) {
      if (value && value !== oldValue) {
        this.newProposta = this.proposta
      }
    },
  },
  created() {
    this.servicosAdicionais = this.value
    if (this.tipoAcresDesc === '%') {
      this.acresDesc = this.tipoAcresDesc
      this.converteValores()
    }
    this.newProposta = this.proposta
  },
  methods: {
    ...mapActions('proposta', ['setCheckOsConstituicao']),
    conferirDesconto(acrescimo, index) {
      let number = 0
      if (this.servicoAdicional[index]) {
        number = verificaAcrescimo(acrescimo, this.tipoAcresDesc)

        let valorComparar = 0
        if (acrescimo && this.servicoAdicional[index].servico) {
          valorComparar = valorParaComparar(this.servicoAdicional[index].servico.valorAuditar, number, this.tipoAcresDesc)
        }

        if (this.servicoAdicional[index].desconto) {
          let desc = 0
          desc = verificaDesconto(this.servicoAdicional[index].desconto, valorComparar, this.tipoAcresDesc)

          this.descontoValido(desc, valorComparar)
        } else {
          // eslint-disable-next-line no-lonely-if
          if (this.tipoAcresDesc === 'R$') {
            this.$refs.descontoInput.erro = false
          } else {
            this.erroPorcentagem = false
          }
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (this.tipoAcresDesc === 'R$') {
          this.$refs.descontoInput.erro = false
        } else {
          this.erroPorcentagem = false
        }
      }
    },
    valorComAcrescimo(desconto, index) {
      let number = 0
      if (this.servicoAdicional[index]) {
        number = verificaAcrescimo(this.servicoAdicional[index].acrescimo, this.tipoAcresDesc)

        let valorComparar = 0
        if (this.servicoAdicional[index].servico) {
          valorComparar = valorParaComparar(this.servicoAdicional[index].servico.valorAuditar, number, this.tipoAcresDesc)
        }

        let desc = 0
        if (desconto) {
          this.servicoAdicional[index].validaDesconto = true
          desc = verificaDesconto(desconto, valorComparar, this.tipoAcresDesc)

          this.descontoValido(desc, valorComparar)
        } else {
          this.servicoAdicional[index].validaDesconto = false
          // eslint-disable-next-line no-lonely-if
          if (this.tipoAcresDesc === 'R$') {
            this.$refs.descontoInput.erro = false
          } else {
            this.erroPorcentagem = false
          }
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (this.tipoAcresDesc === 'R$') {
          this.$refs.descontoInput.erro = false
        } else {
          this.erroPorcentagem = false
        }
      }
    },
    descontoValido(desc, valorComparar) {
      if (desc > valorComparar) {
        if (this.tipoAcresDesc === 'R$') {
          this.$refs.descontoInput.erro = true
        } else {
          this.erroPorcentagem = true
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (this.tipoAcresDesc === 'R$') {
          this.$refs.descontoInput.erro = false
        } else {
          this.erroPorcentagem = false
        }
      }
    },
    getSubTotal(item, acrescimo, desconto) {
      if (item) {
        let subtotal = item.valorAuditar
        if (acrescimo && this.acresDesc === '%' && typeof acrescimo === 'string') {
          subtotal += ((parseFloat(acrescimo.replace('%', ''), 10) / 100) * subtotal)
        } else if (acrescimo) {
          subtotal += acrescimo
        }

        if (desconto && this.acresDesc === '%' && typeof desconto === 'string') {
          subtotal -= ((parseFloat(desconto.replace('%', ''), 10) / 100) * subtotal)
        } else if (desconto) {
          subtotal -= desconto
        }

        return subtotal
      }

      return 0
    },
    servicosNaoHonorarios(items) {
      const servicosNaoHonorarios = items.filter(fil => !fil.honorarioContabil
                                                    && (!fil.atividades || fil.atividades.length === 0)
                                                    && (!fil.tributacoes || fil.tributacoes.length) === 0)
      return servicosNaoHonorarios
    },
    converteValores() {
      for (let index = 0; index < this.servicoAdicional.length; index += 1) {
        this.removeCaracteresValores(this.servicoAdicional[index], index)
        if (this.acresDesc === '%') {
          this.formataPorcentagemAcrescimo(this.servicoAdicional[index].acrescimo, index)
          this.formataPorcentagemDesconto(this.servicoAdicional[index].desconto, index)
        }
      }
    },
    removeCaracteresValores(value, index) {
      if (value.acrescimo) {
        this.servicoAdicional[index].acrescimo = parseFloat(value.acrescimo, 10)
      }

      if (value.desconto) {
        this.servicoAdicional[index].desconto = parseFloat(value.desconto, 10)
      }
    },
    formataPorcentagemAcrescimo(value, index) {
      let acrescimoFormatado = 0
      if (value && value !== '') {
        if (typeof value.acrescimo === 'string') {
          acrescimoFormatado = parseFloat(value.replace('%', ''))
        } else {
          acrescimoFormatado = parseFloat(value, 10)
        }
        this.servicoAdicional[index].acrescimo = !acrescimoFormatado ? `${0}%` : `${acrescimoFormatado}%`
      }
    },
    formataPorcentagemDesconto(value, index) {
      let descontoFormatado = 0
      if (value && value !== '') {
        if (typeof value.desconto === 'string') {
          descontoFormatado = parseFloat(value.replace('%', ''), 10)
        } else {
          descontoFormatado = parseFloat(value, 10)
        }
        this.servicoAdicional[index].desconto = !descontoFormatado ? `${0}%` : `${descontoFormatado}%`
      }
    },
    validar(item) {
      this.$set(item, 'erro', {})

      if (!item.servico) {
        this.$set(item.erro, 'servico', true)
        return false
      }
      return true
    },
    updateCheckOsConstituicao(index) {
      this.servicoAdicional[index].tagComplemento = ''
      this.$emit('update-os-constituicao')
    },
    openModalObs(index) {
      this.indexSaveComplemento = index
      this.$refs.modalObsServico.show()
    },
    editarTag(item, index) {
      this.$refs.modalObsServico.editarTag(item, index)
    },
    RemoveTag(item) {
      this.$refs.modalObsServico.RemoveTag(item)
    },
  },
}
</script>
